import { z } from "zod";

const DailyReportDataV4Schema = z.object({
    date: z.string(),
    rooms: z.number().int(),
    room_sold: z.number().int(),
    daily_revenue: z.string(),
    revpar: z.string(),
    occupancy: z.string(),
    available: z.number().int(),
});

const DailyReportTotalV4Schema = z.object({
    rooms: z.number().int(),
    room_sold: z.number().int(),
    daily_revenue: z.string(),
    revpar: z.string(),
    occupancy: z.string(),
    available: z.number().int(),
});

export const DailyReportResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(DailyReportDataV4Schema),
    total: DailyReportTotalV4Schema,
});

export type DailyReportDataV4 = z.infer<typeof DailyReportDataV4Schema>;
export type DailyReportResponseV4 = z.infer<typeof DailyReportResponseV4Schema>;